<template>
  <div
    v-ripple="assignmentView"
    :style="`${this.canSelect ? 'cursor:pointer;' : ''}`"
    class="reference-tile layout"
    @[event].stop="select(reference)"
  >
    <div v-show="canSelect && !isSelected" :class="`selector`">
      <v-checkbox :disabled="isSelected" :value="selected" color="primary" />
    </div>
    <div class="html-container pa-3" v-html="reference.text" />
    <v-spacer />
    <div
      v-show="!canSelect"
      v-if="isMounted && (!canObserve || (canObserve && isVisible))"
      class="slides pa-3"
    >
      <slide-link v-for="sid in reference.slides" :key="sid" :sid="sid" />
    </div>
    <div class="meta pa-3 ml-5">
      <div class="time">Created {{ reference.createdAt | time }}</div>
      <div class="time">Updated {{ reference.updatedAt | time }}</div>
    </div>
    <div v-show="!canSelect" class="actions pa-3 ml-5">
      <v-dialog v-model="dialog" max-width="500px">
        <template v-slot:activator="{ on }">
          <v-btn icon small @click.stop v-on="on">
            <v-icon>{{ icons.edit }}</v-icon>
          </v-btn>
        </template>
        <edit-reference :item="reference" @close="dialog = false" />
      </v-dialog>
      <v-btn :disabled="canNotBeDeleted" icon small @click.stop="e => deleteReference(reference)">
        <v-icon>{{ icons.trash.toTrash }}</v-icon>
      </v-btn>
    </div>
  </div>
</template>

<script>
import moment from 'moment';
import EditReferenceDialogVue from '../dialogs/EditReferenceDialog.vue';
import ReferenceTileSlideLink from './ReferenceTileSlideLink.vue';
import { confirm } from '@/utils/modal';

import icons from '../../mixins/icons';

const options = {
  root: null,
  threshold: 0,
  rootMargin: '1000px 20px 75px 30px'
};
export default {
  name: 'ReferenceTile',
  components: {
    editReference: EditReferenceDialogVue,
    slideLink: ReferenceTileSlideLink
  },
  filters: {
    time(e) {
      return moment(e).fromNow();
    }
  },
  mixins: [icons],
  props: {
    assignmentView: Boolean,
    initialReference: {
      type: Object
    },
    isSelected: Boolean,
    canSelect: Boolean
  },
  data() {
    return {
      dialog: false,
      isMounted: false,
      canObserve: false,
      isVisible: false,
      reference: this.initialReference,
      selected: this.isSelected || false,
      observer: null
    };
  },
  computed: {
    canNotBeDeleted() {
      return this.reference.slides.length > 0;
    },
    canNotBeUpdated() {
      return this.reference.slides.filter(i => i.status !== 'in_progress').length > 0;
    },
    event() {
      return this.canSelect ? 'click' : null;
    }
  },
  mounted() {
    if (
      'IntersectionObserver' in window &&
      'IntersectionObserverEntry' in window &&
      'intersectionRatio' in window.IntersectionObserverEntry.prototype
    ) {
      this.canObserve = true;
      this.observer = new IntersectionObserver(this.callback, options);
      this.observer.observe(this.$el);
    }
    this.isMounted = true;
  },
  methods: {
    async deleteReference(ref) {
      confirm('Delete Reference', 'Are you sure that you want to delete the reference?', 'Yes', 'No').then(
        async yes => {
          if (yes) {
            await this.$store.dispatch('references/update', { _id: ref._id, active: false });
          }
        }
      );
    },
    callback(entries) {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          this.isVisible = true;
        }
      });
    },
    select(e) {
      this.selected = !this.selected;
      this.$emit('change', e);
    }
  }
};
</script>

<style scoped>
.reference-tile {
  margin-bottom: 10px;
  box-shadow: 0 2px 8px 0 rgba(0, 0, 0, 0.1);
  background-color: #ffffff;
}
.selected {
  background-color: var(--lightish-blue);
}
.slide {
  font-family: 'Roboto', sans-serif;
  font-size: 14px;
  font-weight: 500;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #9b9b9b;
}
.selector {
  cursor: pointer;
  display: inline-flex;
  flex-direction: column;
  align-content: center;
  align-items: center;
  justify-items: center;
  justify-content: center;
  width: 40px;
}
.not-selected {
  background-color: #f5f5f5;
}
.dot {
  width: 10px;
  height: 10px;
  background-color: var(--lightish-blue);
  border-radius: 50%;
}
</style>
